// src/services/ageGrades.ts
import api, { webApi, getCsrfToken } from "../api";

// API provides `GET /age-grade-members` for the authenticated user's age grade
export function getAgeGradeMembers() {
  return api.get(`/age-grade-members`);
}

// Admin: CRUD for age grades under /admin/age-grades
export function getAgeGrades() {
  return api.get(`/age-grades`);
}

export function getAgeGrade(id: string | number) {
  return api.get(`/age-grades/${id}`);
}

export async function createAgeGrade(payload: any) {
  await getCsrfToken();
  return webApi.post(`/admin/age-grades`, payload);
}

export async function updateAgeGrade(id: string | number, payload: any) {
  await getCsrfToken();
  return webApi.put(`/admin/age-grades/${id}`, payload);
}

export async function deleteAgeGrade(id: string | number) {
  await getCsrfToken();
  return webApi.delete(`/admin/age-grades/${id}`);
}
